import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { UserAccountInfo, UserLoginInfo } from '@model/user/user';
import { AppHttpHeadersService } from '../headers/app-http-headers.service';
import { ActiveSession } from '@shared/types/sso';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  constructor(private http: HttpClient, private appHttpHeadersService: AppHttpHeadersService) { }

  login(userLoginInfo: UserLoginInfo): Observable<UserAccountInfo> {
    return this.http.post<UserAccountInfo>(environment.gateway_api + '/accounts/login', userLoginInfo, { headers: this.appHttpHeadersService.getV2Headers() });
  }

  sendTwoFaPassword(two_fa_code: string, password: string): Observable<any> {
    return this.http.post(environment.gateway_api + '/accounts/login/otp-verify', { code: two_fa_code, password: password });
  }

  setNewPassword(newPassword: string, accessToken: string): Observable<any> {
    return this.http.put(environment.gateway_api + '/accounts/expired-password', { new_password: newPassword }, { headers: this.appHttpHeadersService.getAccessTokenHeaders(accessToken) });
  }

  ssoLogin(token: string): Observable<any> {
    return this.http.post(environment.gateway_api + '/accounts/sso-login', { token: token });
  }

  getActiveSessionList(ssoDeviceId: string, deviceType = 'WEB'): Observable<ActiveSession[]> {
    return this.http.get<ActiveSession[]>(environment.gateway_api + `/accounts/sso-login/list-active-session?device_type=${deviceType}&sso_device_id=${ssoDeviceId}`,
      { headers: this.appHttpHeadersService.getHeaders() });
  }

  logoutAllFromDevice(formData: FormData): Observable<any> {
    return this.http.post(environment.gateway_api + `/accounts/sso-login/logout-all-from-device`, formData, { headers: this.appHttpHeadersService.getHeaders() });
  }

  generateToken(formData: FormData): Observable<any> {
    return this.http.post(environment.gateway_api + `/accounts/sso-login/access-token`, formData, { headers: this.appHttpHeadersService.getHeaders() });
  }

  validateToken(token: string): Observable<any> {
    return this.http.get(environment.gateway_api + `/tokens/validate-token`, { headers: this.appHttpHeadersService.getAccessTokenHeaders(token) });
  }

  refreshToken(refreshToken?: string): Observable<any> {
    return this.http.get(environment.gateway_api + `/tokens/refresh`, { headers: this.appHttpHeadersService.getV2RefreshTokenHeaders(refreshToken) });
  }

  desktopClientCheckAccess(accessToken: string): Observable<any> {
    return this.http.get(environment.gateway_api + `/desktop-client/check-access`, { headers: this.appHttpHeadersService.getAccessTokenHeaders(accessToken) });
  }

  logout() {
    return this.http.delete<any>(environment.gateway_api + '/accounts/logout', { headers: this.appHttpHeadersService.getHeaders() });
  }
}
